import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id E758A025-3B14-4A2F-A1D7-2D12C38B47E4
 * name notification-clear-all
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/notification-clear-all.svg
 * tags
 * - Notification 
 */
export const NotificationClearAllIcon = createSvgIcon(<><path d="M5,13H19V11H5M3,17H17V15H3M7,7V9H21V7" /></>, 'NotificationClearAllIcon');
export default NotificationClearAllIcon